<template>
	<span class="display-inline-flex command-btn-like-design with-suffix">
		<div class="text-overflow-ellipsis pr-8" @click="openLink">{{ src }}</div>
		<div @click.prevent="copyLinkToClipboard"><LinkNotationSvg /></div>
	</span>
</template>

<script>
import LinkNotationSvg from './assets/LinkNotationSvg';

export default {
	name: 'LinkCopy',
	components: {
		LinkNotationSvg,
	},
	props: {
		src: { type: String },
	},
	methods: {
		openLink() {
			window.open(this.src, '_blank');
		},
		copyLinkToClipboard() {
			navigator.clipboard.writeText(this.src);
			this.$toast.success('Copied link');
		},
	},
};
</script>

<style scoped lang="scss">
.command-btn-like-design {
	transition: 0.3s;

	&:hover {
		cursor: pointer;
		filter: brightness(90%);
		opacity: 0.8;
		transition: 0.3s;
	}

	::v-deep(svg) {
		top: 4px;
		right: 7px;
		position: absolute;
	}

	&.with-suffix {
		&:before {
			position: absolute;
			top: 0;
			right: 0;
			content: '';
			height: 100%;
			width: 30px;
			background-color: #efeffc;
			z-index: -1;
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
			border-left: 1px solid #5f60dc;
		}
	}
}
</style>
